import { useMemo } from 'react'
import { CanonicalPeriod } from './index'
import ClimateSegmentedField from './ClimateSegmentedField'

type HorizonSelectorProps = {
  value: CanonicalPeriod
  availablePeriods: CanonicalPeriod[]
  onChange: (period: CanonicalPeriod) => void
  label?: string
}

const periodLabels: Record<CanonicalPeriod, string> = {
  [CanonicalPeriod.SHORT_TERM]: '2030',
  [CanonicalPeriod.MID_TERM]: '2050',
  [CanonicalPeriod.LONG_TERM]: '2100',
}

const HorizonSelector = ({
  value,
  availablePeriods,
  onChange,
  label = 'Horizon',
}: HorizonSelectorProps) => {
  const periods = useMemo(
    () => (availablePeriods.length ? availablePeriods : [CanonicalPeriod.LONG_TERM]),
    [availablePeriods],
  )
  const disabled = periods.length <= 1
  const options = useMemo(
    () => periods.map(period => ({ value: period, label: periodLabels[period] })),
    [periods],
  )

  return (
    <ClimateSegmentedField
      label={label}
      helpText="Changes the projection timeframe shown across the page. Year labels are representative horizon markers, not exact single-year values."
      value={value}
      onChange={next => onChange(next as CanonicalPeriod)}
      options={options}
      disabled={disabled}
      ariaLabel="Time horizon"
    />
  )
}

export default HorizonSelector
